const config = {
  BASE_URL: "https://sacd13jmif.execute-api.eu-west-1.amazonaws.com/dev/",
};

export default config;
